import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';

const GradeList = () => {
  const routes = all_routes;

  // Mock data for testing
  const mockGrades = [
    { id: 1, subject: 'Mathematics', grade: 'A', percentage: 92, exam: 'Mid-term', date: '2024-07-15' },
    { id: 2, subject: 'Physics', grade: 'B+', percentage: 87, exam: 'Quiz 1', date: '2024-07-12' },
    { id: 3, subject: 'English', grade: 'A-', percentage: 89, exam: 'Assignment', date: '2024-07-10' },
    { id: 4, subject: 'Chemistry', grade: 'B', percentage: 84, exam: 'Lab Test', date: '2024-07-08' }
  ];

  const mockSummary = {
    totalSubjects: 6,
    averageGrade: 88.5,
    rank: 12,
    totalStudents: 45
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="page-header">
                <div className="row">
                  <div className="col">
                    <h3 className="page-title">Grade List</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={routes.studentDashboard}>Student Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">My Grades</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Grade Summary */}
          <div className="row">
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-primary-transparent me-3">
                      <i className="ti ti-trophy"></i>
                    </div>
                    <div>
                      <h4>{mockSummary.averageGrade}%</h4>
                      <p className="text-muted mb-0">Average Grade</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-success-transparent me-3">
                      <i className="ti ti-medal"></i>
                    </div>
                    <div>
                      <h4>{mockSummary.rank}</h4>
                      <p className="text-muted mb-0">Class Rank</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-warning-transparent me-3">
                      <i className="ti ti-books"></i>
                    </div>
                    <div>
                      <h4>{mockSummary.totalSubjects}</h4>
                      <p className="text-muted mb-0">Total Subjects</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-info-transparent me-3">
                      <i className="ti ti-users"></i>
                    </div>
                    <div>
                      <h4>{mockSummary.totalStudents}</h4>
                      <p className="text-muted mb-0">Class Size</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">My Academic Performance</h4>
                  <p className="text-muted">View your exam results and academic progress</p>
                </div>

                <div className="card-body">
                  {/* Filters */}
                  <div className="row mb-4">
                    <div className="col-md-4">
                      <label className="form-label">Filter by Subject</label>
                      <select className="form-select">
                        <option>All Subjects</option>
                        <option>Mathematics</option>
                        <option>Physics</option>
                        <option>Chemistry</option>
                        <option>English</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Exam Type</label>
                      <select className="form-select">
                        <option>All Exams</option>
                        <option>Mid-term</option>
                        <option>Final</option>
                        <option>Quiz</option>
                        <option>Assignment</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Academic Year</label>
                      <select className="form-select">
                        <option>2024-2025</option>
                        <option>2023-2024</option>
                      </select>
                    </div>
                  </div>

                  {/* TODO Placeholders */}
                  <div className="alert alert-info">
                    <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to grades API</h6>
                    <ul className="mb-0">
                      <li>Fetch student grades from database</li>
                      <li>Calculate GPA and ranking</li>
                      <li>Generate grade reports (PDF)</li>
                      <li>Show grade trends/charts</li>
                    </ul>
                  </div>

                  {/* Grades Table */}
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Subject</th>
                          <th>Exam Type</th>
                          <th>Grade</th>
                          <th>Percentage</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockGrades.map(grade => (
                          <tr key={grade.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="avatar avatar-sm bg-light me-2">
                                  <i className="ti ti-book"></i>
                                </div>
                                {grade.subject}
                              </div>
                            </td>
                            <td>{grade.exam}</td>
                            <td>
                              <span className={`badge ${
                                grade.grade.startsWith('A') ? 'badge-soft-success' :
                                grade.grade.startsWith('B') ? 'badge-soft-primary' :
                                'badge-soft-warning'
                              }`}>
                                {grade.grade}
                              </span>
                            </td>
                            <td>
                              <div className="progress" style={{width: '80px', height: '6px'}}>
                                <div 
                                  className="progress-bar" 
                                  style={{width: `${grade.percentage}%`}}
                                ></div>
                              </div>
                              <small>{grade.percentage}%</small>
                            </td>
                            <td>{grade.date}</td>
                            <td>
                              <button className="btn btn-sm btn-outline-primary me-1">
                                <i className="ti ti-eye"></i>
                              </button>
                              <button className="btn btn-sm btn-outline-success">
                                <i className="ti ti-download"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Action Buttons */}
                  <div className="text-end mt-3">
                    <button className="btn btn-primary me-2">
                      <i className="ti ti-download me-1"></i>Download Report
                    </button>
                    <button className="btn btn-outline-primary">
                      <i className="ti ti-chart-line me-1"></i>View Progress
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GradeList;
